import Abstract from "../../../abstract-view/abstract.js";

export default class Button extends Abstract {
  constructor(element, index) {
    super();

    this._element = element;
    this._index = index;
    this._clickHandler = this._clickHandler.bind(this);
  }

  getProperty() {
    return this.getElement().dataset.property;
  }

  getValue() {
    return this.getElement().dataset.value;
  }

  setClickHandler(callback) {
    this._callback.click = callback;
    this.getElement().addEventListener(`click`, this._clickHandler);
  }

  _clickHandler(evt) {
    evt.preventDefault();
    this._callback.click(this._index);
  }
}
